export default __webpack_public_path__ + "static/media/einstientk.d3f90aa6.jpg";